export default __webpack_public_path__ + "static/media/1160.901ba31d.png";